module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"main_title":"PSH topics recommendations"},"cs":{"main_title":"Doporučená PSH témata"}}')
  delete Component.options._Ctor
}
